import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SmoothScroll from "@/components/SmoothScroll";
import Preloader from "@/components/Preloader";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import DoctorSpotlight from "@/components/DoctorSpotlight";
import Services from "@/components/Services";
import WhyUs from "@/components/WhyUs";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import FindUs from "@/components/FindUs";
import BookConsultation from "@/components/BookConsultation";
import JournalTeaser from "@/components/JournalTeaser";
import Footer from "@/components/Footer";
import BlogList from "@/pages/BlogList";
import BlogArticle from "@/pages/BlogArticle";

const Home = () => (
  <main data-testid="home-main" className="grain">
    <Preloader />
    <SmoothScroll />
    <Navbar />
    <Hero />
    <Marquee />
    <Manifesto />
    <DoctorSpotlight />
    <Services />
    <WhyUs />
    <Testimonials />
    <JournalTeaser />
    <FAQ />
    <FindUs />
    <BookConsultation />
    <Footer />
  </main>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
